import { supabase } from '../lib/supabase';

const DELETE_USER_FUNCTION_NAME = 'delete-user';
const DEFAULT_DELETE_TIMEOUT_MS = 45000;

const getFunctionUrl = () => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  if (!supabaseUrl) throw new Error('Supabase URL is not configured.');
  return `${supabaseUrl.replace(/\/$/, '')}/functions/v1/${DELETE_USER_FUNCTION_NAME}`;
};

const readResponseJson = async (response) => {
  try {
    return await response.json();
  } catch (error) {
    return {};
  }
};

export const revokePortalUser = async ({ row, hoaId }) => {
  const userId = row?.auth_user_id || row?.profile?.id || null;
  const invitationId = row?.invitation_id || null;
  if (!hoaId || (!userId && !invitationId)) {
    throw new Error('The selected portal user could not be identified.');
  }

  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) throw sessionError;

  const accessToken = sessionData?.session?.access_token;
  if (!accessToken) throw new Error('You must be signed in before deleting portal users.');

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), DEFAULT_DELETE_TIMEOUT_MS);

  try {
    const response = await fetch(getFunctionUrl(), {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        apikey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        hoa_id: hoaId,
        user_id: userId,
        invitation_id: invitationId,
      }),
      signal: controller.signal,
    });

    const data = await readResponseJson(response);
    if (!response.ok || data?.error) {
      throw new Error(data?.error || `Delete request failed with status ${response.status}`);
    }
    return data;
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw new Error('The delete request timed out. Refresh the user list before trying again.');
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};
